import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './cohostOnboarding.css';

const LABELS = {
    owner_coowner: 'Owner / Co-owner',
    cleaner: 'Cleaner',
    view: 'View only'
};

const toTitle = (value) => {
    const normalized = String(value || '').trim();
    if (!normalized) return 'Capability';
    return normalized
        .split('.')
        .join(' ')
        .split('_')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
};

const CohostOnboardingPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const payload = location.state || {};
    const propertyId = Number(payload.propertyId || params.propertyId);
    const propertyName = String(payload.propertyName || 'Property').trim();
    const role = String(payload.role || 'view').trim().toLowerCase();
    const capabilities = Array.isArray(payload.capabilities) ? payload.capabilities : [];

    return (
        <div className="cohost-onboarding-page">
            <section className="cohost-onboarding-card">
                <p className="cohost-onboarding-kicker">Co-host Access Activated</p>
                <h2>Welcome to {propertyName}</h2>
                <p className="cohost-onboarding-copy">
                    Your invite has been accepted and your account is now connected to this property.
                    Review your role and permissions below.
                </p>

                <div className="cohost-onboarding-role">
                    <span>Role</span>
                    <strong>{LABELS[role] || role}</strong>
                </div>

                <div className="cohost-onboarding-capabilities">
                    <h3>Current Capabilities</h3>
                    {capabilities.length === 0 ? (
                        <p className="cohost-onboarding-muted">No explicit capabilities were provided.</p>
                    ) : (
                        <ul>
                            {capabilities.map((capability) => (
                                <li key={capability}>{toTitle(capability)}</li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className="cohost-onboarding-actions">
                    <button type="button" className="btn-primary" onClick={() => navigate('/Properties')}>
                        Go To Properties
                    </button>
                    {propertyId > 0 && (
                        <button type="button" className="btn-secondary" onClick={() => navigate(`/PropertyDetails/${propertyId}`)}>
                            Open Property Workspace
                        </button>
                    )}
                </div>
            </section>
        </div>
    );
};

export default CohostOnboardingPage;
